import { render, staticRenderFns } from "./ListClientsPage.vue?vue&type=template&id=56014422&scoped=true"
import script from "./ListClientsPage.vue?vue&type=script&lang=js"
export * from "./ListClientsPage.vue?vue&type=script&lang=js"
import style0 from "./ListClientsPage.vue?vue&type=style&index=0&id=56014422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56014422",
  null
  
)

export default component.exports